/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/**
 * Takes an array of price history objects and identifies in stock and OOS
 * status and prices.
 * n.b. Out of Stock is presented as null so needs to be given the last known in stock price
 * @param productHistory {Array}
 * @returns {Array}
 */
function stockStatus(priceHistory) {
    let updatedData = [];

    if (priceHistory[0].price === null) {
        priceHistory.shift();
    }

    updatedData = priceHistory.map((priceChange, i, arr) => {
        let price = priceChange.price;
        let isOOS = false;

        if (price === null) {
            price = arr[i - 1].price;
            isOOS = true;
        }

        return {
            date: new Date(priceChange.date * 1000),
            price,
            isOOS
        };
    });

    return updatedData;
}

/**
 * Transform the pruductHistory data for easier use with d3
 * @param productHistory {Array}
 * @returns {Object}
 */
export function formatData(productHistory) {
    const data = {};

    productHistory.forEach(retailer => {
        const retailerName = retailer.retailer;
        const updatedData = stockStatus(retailer.price_history);
        const last = updatedData[updatedData.length - 1];

        updatedData.push({
            date: new Date(),
            price: last.price,
            isOOS: last.isOOS
        });

        data[retailerName] = updatedData;
    });

    return data;
};

/**
 * Used for creating the lower value on the y-axis of a graph.
 * The cushion parameter is the maximum amount the price should be lowered by.
 * @param price {Number}
 * @param cushion {Number}
 * @returns {Number}
 */
export function lowerPriceBound(price, cushion) {
    const mod = price % cushion;

    if (price <= cushion) {
        return 0;
    }

    if (mod === 0) {
        return price - cushion;
    }

    return price - mod;
}

/**
 * Used for creating the upper value on the y-axis of a graph.
 * The cushion parameter is the maximum amount the price should be increased by.
 * @param price {Number}
 * @param cushion {Number}
 * @returns {Number}
 */
export function upperPriceBound(price, cushion) {
    const mod = price % cushion;

    if (mod !== 0) {
        return price + (cushion - mod);
    }

    return price + cushion;
}

